<h3 mat-dialog-title>Unlink {{data.account.friendlyName}}?</h3>

<mat-dialog-content>
    <p>
        By unlinking this account you will no longer be able to import transaction data or live balances from this bank
        account. Re-connecting this bank account at a later date may result in duplicate transaction data being created.
    </p>
    <p *ngIf="data.account.linkedBankAccount.pullsTransactions">
        If you wish to disable transaction synchronization, please
        <a (click)="disableTransactions()" class="add-blue">click here</a> to
        turn this feature off instead.
    </p>
    <p>Are you sure that you wish to continue?</p>
</mat-dialog-content>

<mat-dialog-actions>
    <button (click)="closeDialog()" [disabled]="isDeleteInFlight" class="btn btn-outline-secondary">
        No, Keep Linked
    </button>
    <button (click)="deleteAccount()"
            [disabled]="isDeleteInFlight"
            class="btn btn-primary">
        Yes, Unlink Account
    </button>
</mat-dialog-actions>
